import {skipToken} from '@reduxjs/toolkit/query';

import {isNil} from 'ramda';

import {BusinessCaseResponseBody} from '@dms/api/sales';
import {useGetSaleVehicleQuery} from '@dms/api/vehicle';

import {isNotNilOrEmpty, Nullish} from 'shared/web';

import {getSaleVehicleIdFromBusinessCase} from '../utils/getSaleVehicleIdFromBusinessCase';
import {getTradeInViewState} from '../utils/getTradeInViewState';

export function useTradeInViewState(businessCase: BusinessCaseResponseBody | Nullish) {
  const saleVehicleId = getSaleVehicleIdFromBusinessCase(businessCase ?? undefined);

  const {data: vehicle} = useGetSaleVehicleQuery(
    isNotNilOrEmpty(saleVehicleId) ? {vehicleId: saleVehicleId} : skipToken
  );

  if (isNil(businessCase)) {
    return null;
  }

  return getTradeInViewState({
    businessCaseType: businessCase.businessCaseType,
    businessCaseState: businessCase.businessCaseState,
    linkedTradeInBusinessCaseId: businessCase.linkedTradeInBusinessCaseId,
    isVehicleAvailable: vehicle?.isAvailable,
  });
}
